import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useLanguage } from '../../i18n';
import { usePrefersReducedMotion } from '../../hooks/useMediaQuery';
import { logosColaboracionesHome } from '../../assets/images/logo';
import './Colaboraciones.scss';

gsap.registerPlugin(ScrollTrigger);

const Colaboraciones = () => {
  const { t } = useLanguage();
  const reduceMotion = usePrefersReducedMotion();
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    if (reduceMotion) return undefined;

    const ctx = gsap.context(() => {
      gsap.fromTo(
        titleRef.current,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: { trigger: titleRef.current, start: 'top 80%' },
        },
      );

      gsap.fromTo(
        '.colaboraciones__line',
        { scaleX: 0 },
        {
          scaleX: 1,
          duration: 1.5,
          ease: 'power2.inOut',
          scrollTrigger: { trigger: '.colaboraciones__line', start: 'top 80%' },
        },
      );

      gsap.fromTo(
        imageRef.current,
        { opacity: 0, scale: 0.9, y: 50 },
        {
          opacity: 1,
          scale: 1,
          y: 0,
          duration: 1.2,
          ease: 'power3.out',
          scrollTrigger: { trigger: imageRef.current, start: 'top 75%' },
        },
      );
    }, sectionRef);

    return () => ctx.revert();
  }, [reduceMotion]);

  return (
    <section
      className="colaboraciones colaboraciones--home"
      id="colaboraciones"
      ref={sectionRef}
      aria-labelledby="colaboraciones-title"
    >
      <div className="container">
        <div className="colaboraciones__header">
          <h2
            id="colaboraciones-title"
            className="colaboraciones__title"
            ref={titleRef}
          >
            {t('colaboraciones.title')}
          </h2>
          <div className="colaboraciones__line" aria-hidden="true" />
        </div>

        <div className="colaboraciones__content">
          <div className="colaboraciones__image-wrapper" ref={imageRef}>
            <img
              src={logosColaboracionesHome}
              alt={t('colaboraciones.imageAlt')}
              className="colaboraciones__image"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Colaboraciones;
